export function useCacheProviderAPI() {
  const { errors, request } = useRequestV2();

  async function fetchAccountSettings(requestBody: (keyof AccountSettings)[]) {
    const url = 'V3/AccountSettings/ById';
    const requestOptions: RequestOptions = {
      method: 'post',
      body: requestBody
    };

    return await request<AccountSetting[]>(url, requestOptions);
  }

  return {
    errors,
    fetchAccountSettings
  };
}
